import { Builder } from '@tko/builder'

import { VirtualProvider } from '@tko/provider.virtual'
import { DataBindProvider } from '@tko/provider.databind'
import { ComponentProvider } from '@tko/provider.component'
import { AttributeProvider } from '@tko/provider.attr'
import { MultiProvider } from '@tko/provider.multi'
import { TextMustacheProvider, AttributeMustacheProvider } from '@tko/provider.mustache'
import { NativeProvider } from '@tko/provider.native'

import { bindings as coreBindings } from '@tko/binding.core'
import { bindings as templateBindings } from '@tko/binding.template'
import { bindings as ifBindings } from '@tko/binding.if'
import { bindings as foreachBindings } from '@tko/binding.foreach'
import { bindings as componentBindings } from '@tko/binding.component'

import { filters } from '@tko/filter.punches'

import components from '@tko/utils.component'
import { createElement, Fragment } from '@tko/utils.jsx'
import { JsxObserver } from '@tko/utils.jsx'

import { options } from '@tko/utils'

declare const BUILD_VERSION: string

/** Use === and !== instead of == and != in binding expressions */
options.strictEquality = true

const builder = new Builder({
  filters,
  extenders: {},
  options: {},
  provider: new MultiProvider({
    providers: [
      new ComponentProvider(),
      new NativeProvider(),
      new AttributeMustacheProvider(),
      new TextMustacheProvider(),
      new DataBindProvider(),
      new VirtualProvider(),
      new AttributeProvider()
    ]
  }),
  bindings: [
    coreBindings,
    templateBindings,
    ifBindings,
    foreachBindings,
    componentBindings,
    { each: foreachBindings.foreach }
  ]
})

const version = BUILD_VERSION

export default builder.create({
  jsx: {
    createElement,
    Fragment,
    /** Public render function that converts JSX to DOM nodes */
    render(jsx: any) {
      const fragment = document.createDocumentFragment()
      const observer = new JsxObserver(jsx, fragment)
      // Return the first child if single node, or the fragment if multiple
      const node = fragment.childNodes.length === 1 ? fragment.firstChild : fragment
      return {
        node,
        dispose: () => observer.dispose()
      }
    }
  },
  components,
  version,
  Component: components.ComponentABC
})
